var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVideoIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    verticalAlign: "middle"
  }
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.25 6.75C1.25 6.33579 1.58579 6 2 6H13C14.5188 6 15.75 7.23122 15.75 8.75V17.75C15.75 18.1642 15.4142 18.5 15 18.5H4C2.48122 18.5 1.25 17.2688 1.25 15.75V6.75ZM2.75 7.5V15.75C2.75 16.4404 3.30964 17 4 17H14.25V8.75C14.25 8.05964 13.6904 7.5 13 7.5H2.75Z",
  fill: "#051F4E"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.7498 8.11478C20.9538 8.03061 21.1738 7.99317 21.3907 8.00102C21.6077 8.00888 21.8254 8.06226 22.0237 8.16303C22.2221 8.2638 22.4033 8.41344 22.5367 8.61047C22.6713 8.80906 22.7501 9.04625 22.75 9.29815V15.2016C22.75 15.4535 22.6711 15.6907 22.5366 15.8892C22.4032 16.0861 22.2222 16.2356 22.0241 16.3365C21.8259 16.4373 21.6085 16.4908 21.3916 16.4989C21.1747 16.507 20.9548 16.4699 20.7506 16.386L17.7148 15.1376C17.3317 14.9801 17.1488 14.5418 17.3064 14.1588C17.4639 13.7757 17.9021 13.5928 18.2852 13.7504L21.25 14.9695V9.53096L18.2852 10.7501C17.9021 10.9076 17.4639 10.7248 17.3064 10.3417C17.1488 9.9586 17.3317 9.52034 17.7148 9.36281L20.7498 8.11478Z",
  fill: "#051F4E"
})));
export default SvgVideoIcon;